import React from 'react';
import './ContentPanel.css';
import TutorialList from '../tutorial/TutorialList'; 
import Tutorial from '../tutorial/Tutorial';
import 
{
 
 Routes,
 Route

 
} from 'react-router-dom';
import AboutUs from '../aboutus/AboutUs';
import ContactUs from '../ContactUs/ContactUs';

function ContentPanel() {
    return (
        
          <Routes>
             <Route path='/' element={<TutorialList/>} />
             <Route path='/tutorial' element={<Tutorial/>} />
             <Route path='/tutorial/:slug' element={<Tutorial/>} />
             <Route path='/aboutus' element={<AboutUs/>} />
             <Route path='/contactus' element={<ContactUs/>} />
            </Routes>  
       
        
    )
}

export default ContentPanel